import { apiRequest } from "src/utils/apiRequest";

/** Mirrors the backend `InspectionUrgency` enum. */
export type InspectionUrgency = "DUE" | "UPCOMING";

/**
 * A single scheduled inspection from AUSTIN, as returned by
 * GET /inspections/scheduled. Mirrors the backend `ScheduledInspection` model.
 */
export interface ScheduledInspection {
    austinInspectionId: string;
    name: string;
    status: string;
    assignee?: string | null;
    scheduledDateTime?: string | null;
    dueDate?: string | null;
    urgency?: InspectionUrgency | null;
}

class AustinInspectionService {
    /**
     * Fetch the current inspection to surface in the workflow card for a site:
     * the earliest DUE inspection if one exists, otherwise the earliest UPCOMING
     * inspection. Resolves to null when there is nothing to show.
     *
     * @param siteCode Site code selected in the toggle (e.g. "DEMO1").
     */
    async getCurrentScheduledInspection(
        siteCode: string
    ): Promise<ScheduledInspection | null> {
        const data = await apiRequest<ScheduledInspection | null>({
            url: `/inspections/scheduled`,
            method: "GET",
            params: { site_code: siteCode },
        });
        return data ?? null;
    }
}

export default new AustinInspectionService();
